export default "__VITE_ASSET__BsrYEhgH__"